/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Company = 0, Proximity = 1
 */
export enum Routemize_Constants_UltimateSlotPriority {
    COMPANY = 'Company',
    PROXIMITY = 'Proximity',
}
